<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>CẬP NHẬT KỲ THI</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 pt-6 pb-0">
        <v-form v-bind="this.$attrs" ref="form">
          <v-text-field
            label="Tên kỳ thi"
            v-model="name"
            outlined
            required
            :rules="[$rules.required]"
            class="required"
          ></v-text-field>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date"
                label="Ngày"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker v-model="date" no-title scrollable @input="menu = false" />
          </v-menu>
          <v-text-field
            label="Địa điểm"
            v-model="location"
            outlined
            required
            :rules="[$rules.required]"
            class="required pt-6"
          ></v-text-field>
          <v-select
            label="Loại thi"
            :items="typeOptions"
            item-text="label"
            item-value="value"
            v-model="type"
            outlined
            :rules="[$rules.required]"
            class="required"
          ></v-select>
          <v-file-input
            v-model="files"
            show-size
            outlined
            counter
            dense
            label="Chọn file tải lên tại đây"
            append-icon="mdi-upload"
            prepend-icon=""
            :clearable="false"
          ></v-file-input>
          <v-select
            label="Trạng thái"
            :items="statusOptions"
            item-text="label"
            item-value="value"
            v-model="status"
            outlined
            :rules="[$rules.required]"
            class="required"
          ></v-select>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    state: Boolean,
    data: Object
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    },
    data: {
      immediate: true,
      handler(newData) {
        if (newData) {
          this.setFormValues(newData)
        }
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  data() {
    return {
      dialog: false,
      loading: false,
      name: '',
      type: '',
      gradeReview: 'true',
      date: '',
      location: '',
      status: '',
      files: null,
      menu: false,
      typeOptions: [
        { label: 'Giữa kỳ', value: 'midTerm' },
        { label: 'Cuối kỳ', value: 'final' },
        { label: 'Thi khác', value: 'extra' }
      ],
      reviewOptions: [
        { label: 'Có', value: 'true' },
        { label: 'Không', value: 'false' }
      ],
      statusOptions: [
        { label: 'Đang hoạt động', value: 'active' },
        { label: 'Đã bị khóa', value: 'inActive' },
        { label: 'Đã bị xóa', value: 'removed' }
      ]
    }
  },
  methods: {
    ...mapActions('exam', ['updateExam']),
    ...mapActions('upload', ['upload', 'uploadMany', 'destroy']),

    close() {
      this.$emit('closeDialog')
      this.$refs.form.resetValidation()
    },
    async submit() {
      if (this.$refs.form.validate()) {
        try {
          this.$loading.active = true
          let fileIds
          let data = {
            name: this.name,
            type: this.type,
            gradeReview: this.gradeReview,
            date: this.date,
            location: this.location,
            status: this.status
          }
          if (this.files) {
            fileIds = await this.uploadStudyRecords([this.files])
            if (!fileIds) throw new Error('Tải tài liệu lên thất bại')
            data.files = fileIds
          }
          await this.updateExam({ id: this.data.id, ...data })

          this.$emit('refresh')
          this.resetForm()
          this.close()
        } catch (e) {
          this.$alert.error('Lỗi cập nhập kỳ thi')
          console.error(e)
        } finally {
          this.$loading.active = false
        }
      }
    },
    async uploadStudyRecords(images) {
      let formData = new FormData()
      for (let i = 0; i < images.length; i++) {
        formData.append('files', images[i])
      }
      formData.append('files', images)
      formData.append('refId', this.data.id)
      formData.append('field', 'studyRecordFiles')
      return this.uploadMany(formData)
    },
    resetForm() {
      this.name = ''
      this.acronym = ''
      this.grade = ''
      this.note = ''
      this.type = ''
      this.phase = ''
    },
    setFormValues(data) {
      this.name = data.name || ''
      this.grade = data.grade || ''
      this.type = data.type || ''
      this.location = data.location || ''
      this.status = data.status || ''
      this.phase = data.phase || ''
      this.gradeReview = typeof data.gradeReview === 'boolean' ? data.gradeReview.toString() : ''
      this.files = data.files
      if (data.date) {
        const parsedDate = new Date(data.date).toISOString().split('T')[0]
        this.date = parsedDate
      } else {
        this.date = ''
      }
    }
  }
}
</script>

<style>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 2px !important;
}
</style>
